<form class="form vc-admin-form vc-admin-role-form" [formGroup]="form" (ngSubmit)="execute()" novalidate>
  @if (showIntro) {
  <header class="vc-admin-form__intro">
    <h3 class="vc-admin-form__title">{{ formTitleKey | translate }}</h3>
    <p class="vc-admin-form__subtitle">{{ formDescriptionKey | translate }}</p>
  </header>
  }

  <section class="vc-admin-form__section">
    <h4 class="vc-admin-form__section-title">{{ 'COMMON.INFO' | translate }}</h4>
    <div class="grid">
      <div class="col-12 md:col-6">
        <div class="field">
          <label for="name">{{ 'COMMON.ROLE_NAME' | translate }} *</label>
          <input id="name" name="name" pInputText type="text" formControlName="name" fluid />
          <small id="user-name-help" class="p-error"
            *ngIf="(submitted || form.controls['name'].touched) && errors.name">
            {{ errors.name | translate }}
          </small>
        </div>
      </div>
    </div>
  </section>

  @if (mode === 'create') {
  <section class="vc-admin-form__section">
    <h4 class="vc-admin-form__section-title">{{ 'ADMIN.ROLES.DETAIL.PERMISSIONS_TITLE' | translate }}</h4>
    <p class="vc-admin-form__section-subtitle">
      {{ 'ADMIN.ROLES.CREATE.PERMISSIONS_HINT' | translate }}
    </p>
    <p class="vc-admin-form__section-subtitle">
      {{ 'ADMIN.ROLES.DETAIL.AVAILABLE_PERMISSIONS_HINT' | translate }}
    </p>

    <div class="vc-role-permissions">
      @for (group of groupedResources; track group.code) {
      <section class="vc-role-permissions__group">
        <header class="vc-role-permissions__group-header">
          <h4>{{ getDomainTitle(group.code) }}</h4>
          <p>{{ getDomainDescription(group.code) }}</p>
        </header>

        <div class="vc-role-permissions__rows">
          @for (resource of group.resources; track resource.id) {
          <article class="vc-role-permissions__row">
            <div class="vc-role-permissions__row-copy">
              <p class="vc-role-permissions__row-title">
                {{ resource.name | resourceLabel : "TITLE" }}
              </p>
              <p class="vc-role-permissions__row-description">
                {{ resource.name | resourceLabel : "DESCRIPTION" }}
              </p>
            </div>

            <div class="vc-role-permissions__row-action">
              <p-inputSwitch name="resource-{{resource.id}}" [ngModelOptions]="{ standalone: true }"
                [(ngModel)]="permissionsStatus[resource.id]"></p-inputSwitch>
            </div>
          </article>
          }
        </div>
      </section>
      }
    </div>
  </section>
  }

  <app-admin-form-actions primaryLabelKey="COMMON.SAVE" [submitting]="submitting"></app-admin-form-actions>
</form>